import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import Icon from './Icon';
import { requestLocation } from '../lib/location';
import Button from './Button';

function GeolocationButton({ className, icon, loadingText, text, onClick, onLocate }) {
  const { t } = useTranslation();
  const [status, setStatus] = useState('waiting');
  const cssClass = `${className || 'dealers-button'} main w-icon ${status === 'loading' ? ' loading' : ''} geolocation-button`;

  const clickHandler = () => {
    if (status === 'waiting') {
      setStatus('loading');
      requestLocation().then((result) => {
        setStatus('waiting');

        if(typeof onLocate === 'function') {
          onLocate(result);
        }
      }).catch(() => {
        setStatus('error');
      });
    }

    if(typeof onClick === 'function') {
      onClick();
    }
  }

  const statusText = {
    waiting: text || t('Use my location'),
    loading: loadingText || t('Loading location'),
    error: t('Location unavailable'),
  };

  return (
    <Button
      variation="geolocate"
      label={statusText[status]}
      loading={status === 'loading'}
      icon={icon || 'Location-White'}
      disabled={status === 'error'}
      onClick={clickHandler}
    />
  )
}

GeolocationButton.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.string,
  loadingText: PropTypes.string,
  text: PropTypes.string,
  onClick: PropTypes.func,
  onLocate: PropTypes.func,
};

export default GeolocationButton;
